/***
 * 创建人：但志强
 * 时间：2019-06-11
 * 描述: tab的右键菜单
 * 使用说明: 参考 sw-right-click-menu 配置应用说明文档
 * 更新说明:
 */
import { Component, OnInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { SwRouteguardService } from 'src/app/librarys/serves/sw-routeguard.service';
import { SwSimpleReuseStrategy } from 'src/app/librarys/serves/sw-simplereusestrategy';
import { SwTabService } from 'src/app/librarys/serves/public/sw-tab.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { environment } from 'src/environments/environment';
declare var $:any
@Component({
  selector: 'sw-right-click-menu',
  templateUrl: './sw-right-click-menu.component.html',
  styleUrls: ['./sw-right-click-menu.component.css']
})
export class SwRightClickMenuComponent implements OnInit {
  
  //此事件是否禁用,最后一个刷新功能全都可以使用
  disabledMe:boolean = false
  disabledOthers:boolean = false
  disabledRight:boolean = false
  dashboard:string  //项目默认的工作台
  singleTab:boolean = false  //是否是单页签模式

 
  @ViewChild("Menu") menu:ElementRef
  menuList: Array<{path: string, isSelect: boolean,queryParams:any ,preTab?:any}> = [];
  constructor(
    private menuTab:SwRouteguardService,
    private swTab: SwTabService,
    private router:Router,
    private el:ElementRef,
    private rot: SwRouteguardService,
    private jwt: SwJwtService,) { 
    this.menuList = menuTab.getMenus();
  }

  ngOnInit() {
    this.dashboard = environment.defaultPortal  //从环境文件中获取默认工作台
    this.singleTab = environment.singleTab  //从环境文件中获取单/多页签模式
    this.menuTab.valueUpdated.subscribe((val)=>{
        this.menuList = val
      })
  }

  routerMenu:any;  //事件源标签

  //点击右键菜单
  RightMenu(event:any,menus:any){
    this.disabledMe = false  //关闭当前按钮禁用
    this.disabledOthers = false  //关闭其他按钮禁用
    this.disabledRight = false  //关闭右侧按钮禁用
    this.el.nativeElement.style.display = 'block'
    this.routerMenu = menus;
    let newdisX = event.x;
    let newdisY = event.y;
    this.menu.nativeElement.style.position="absolute"
    this.menu.nativeElement.style.display="block"
    this.menu.nativeElement.style.left = newdisX + 'px';
    this.menu.nativeElement.style.top = newdisY + document.body.scrollTop + 'px';
    clickBody() //触发鼠标点击监听事件
    this.cursor()
  }

  //判断右键菜单可以使用的菜单的数量
  cursor(){
    if(this.routerMenu.path.indexOf(this.dashboard) != -1){  
      //如果当前的tab页是工作台,就禁用关闭当前
      this.disabledMe = true
    }
    if(this.menuList.length == 1 && this.routerMenu.path.indexOf(this.dashboard) != -1){
      //如果当前的tab页是工作台,就禁用关闭当前
      this.disabledMe = true
      //且tab只有这一个,那么也要禁用关闭其他
      this.disabledOthers = true
    }
    if(this.routerMenu == this.menuList[this.menuList.length-1]){
      //如果当前tab页就是最右侧的,那么就禁用关闭右侧
      this.disabledRight = true
    }
    if(this.menuList.length == 2 && this.menuList[1] == this.routerMenu){
      //如果只有两个tab页,且当前tab不是工作台,就禁用关闭其他
      this.disabledOthers = true
    }
  }
  //1点击关闭当前标签
  // 1.1工作台标签,没有此事件
  // 1.2如果事件源标签和显示标签不是同一个,那么关闭事件源标签后,显示标签不变
  // 1.3如果事件源标签和显示标签是同一个,如果事件源标签不是数组的最后一个,那么关闭事件源标签后,显示事件源标签右侧的标签,如果是最后一个,就显示左侧标签
  clickRightCloseThis(event){
    event.stopPropagation();
    if(this.disabledMe == true){
      //如果禁用此事件,就不执行以下代码,事件不消失
      this.el.nativeElement.style.display = 'block'
      return
    }
    this.swTab.closeUrl(this.routerMenu.path,this.routerMenu.isSelect)
    //右键事件菜单消失
    this.el.nativeElement.style.display = 'none'
  }


  //2.点击关闭其他标签
  //如果事件源标签和显示标签是同一个,就关闭工作台和这个标签之外的所有标签,如果不是同一个,就删掉除工作台和事件源标签之外的所有标签,显示事件源标签
  // 2.1.如果当前只有工作台标签存在就不进行任何操作
  // 2.2.如果是在工作台标签上右键点击关闭其他标签,就关闭其他,最后显示工作台标签就行
  // 2.3.如果在工作台标签之外的标签上触发此事件,就保留工作台和这个标签,显示这个标签
  clickRightCloseOthers(event){
    if(this.disabledOthers == true){
      //如果禁用此事件,就不执行以下代码,事件不消失
      this.el.nativeElement.style.display = 'block'
      return
    }
    //1.获取当前高亮标签  currenTab
    let currenTab = this.menuList.filter(item=>item.isSelect)[0]
    //2.事件源标签已经获取了  this.routerMenu
    //3.如果事件源标签是工作台
    if(this.routerMenu.path.indexOf(this.dashboard) != -1){
      //找到要保留才tab 和要删除的tab,只保留工作台,其他都删除
      let reserveMenuList = this.menuList.filter(item=>item.path.indexOf(this.dashboard) != -1)
      let deletMenuList = this.menuList.filter(item=>item.path.indexOf(this.dashboard) == -1)
      //删除出工作台之外的tab
      this.menuList = this.menuList.filter(item=>item.path.indexOf(this.dashboard) != -1);
      this.menuList[0].isSelect = true
      //对删除之后的菜单 发布 保存缓存
      this.menuTab.valueUpdated.next(this.menuList);
      this.rot.setMenu(this.menuList);
      //this.jwt.setToKen("TabMenu", JSON.stringify(this.menuList));
      //删除其他的路由复用

      deletMenuList.forEach(item=>{
        setTimeout(() => {
          SwSimpleReuseStrategy.deleteRouteSnapshot(item.path);     //删除复用
          
        }, 100);
      })
      //跳转到工作台
      this.router.navigate([reserveMenuList[0].path],{
        queryParams:{
          'title':reserveMenuList[0].queryParams
        }
      })
      
    } else if(this.routerMenu.path != currenTab.path){  //如果事件源标签是工作台之外的标签,且不是当前标签
      //找到要删除的标签
      let deletMenuList = this.menuList.filter(item=>item.path.indexOf(this.dashboard) == -1  && item.path != this.routerMenu.path)
      //将 this.menuList 更新为要保留的标签
      this.menuList = this.menuList.filter(item=>item.path.indexOf(this.dashboard) != -1 || item.path == this.routerMenu.path);
      //对要选中高亮的标签重新赋值
      this.menuList.forEach(item=> item.isSelect = item.path == this.routerMenu.path)
      //对删除之后的菜单 发布 保存缓存
      this.menuTab.valueUpdated.next(this.menuList);
      this.rot.setMenu(this.menuList);
      //this.jwt.setToKen("TabMenu", JSON.stringify(this.menuList));
      //删除其他的路由复用
      deletMenuList.forEach(item=>{
        setTimeout(() => {
          SwSimpleReuseStrategy.deleteRouteSnapshot(item.path);     //删除复用
          
        }, 100);
        
      })
      //跳转到本身
      let newCurrentMune = this.menuList.filter(item=>item.isSelect)[0]
      this.router.navigateByUrl('').then(() => {
        this.router.navigate([newCurrentMune.path], {
          queryParams: newCurrentMune.queryParams
        })
      })
    } else {
      //获取事件源标签的索引,删掉该索引后面的元素,之后事件源标签就是数组中的最后一个元素
      this.menuList.forEach(item=>{
        if(item.path.indexOf(this.dashboard) == -1 && item.path != this.routerMenu.path){
          //如果该菜单不是工作台且不是事件源菜单,就关闭
          this.swTab.closeUrl(item.path,item.isSelect);
        }
      })
    }
    

    

    //(1.拿到缓存的tab 过滤出保留的 以及删除的 部分 )
    //1.判断工作是否是关闭其他 
    //2.删除 掉其他tab菜单菜单 发布 保存缓存
    //3.删除 其他路由复用 
    //4.跳转到工作台 
    
    
    //1.保留工作台以及本身
    //2.删除 掉其他tab菜单菜单 发布 保存缓存
    //3.删除 其他路由复用 
    //4.跳转到本身 

    //
    
    // //找到显示的那个标签,改变地址栏,使之跳转到对应的路由
    // let showMenu = this.menuList.filter(item=>item.isSelect == true)
    // //路由跳转
    // this.router.navigate([showMenu[0].path],{
    //   queryParams:{
    //     'title':showMenu[0].queryParams.Title
    //   }
    // })
    this.el.nativeElement.style.display = 'none'
  }
  
  //3.点击关闭右侧标签,最终显示事件源标签
  // 3.1.如果事件源标签和显示标签是同一个,就直接关闭后面的标签
  // 3.2.如果事件源标签和显示标签不是同一个就关闭事件源标签右侧所有标签,并显示事件源标签
  clickRightCloseRight(evevt){
    if(this.disabledRight == true){
      //如果禁用此事件,就不执行以下代码,事件不消失
      this.el.nativeElement.style.display = 'block'
      return
    }
    //获取事件源标签的索引,删掉该索引后面的元素,之后事件源标签就是数组中的最后一个元素
    let index = this.menuList.findIndex(item=>item.path == this.routerMenu.path)
    for(var i=this.menuList.length-1; i>0; i--){
      if(i > index){
        this.swTab.closeUrl(this.menuList[i].path,this.menuList[i].isSelect);
      }
    }

    this.el.nativeElement.style.display = 'none'
  }

  //4.点击刷新当前标签,跳转到当前标签
  //注意: 由于设置了路由复用,跳转路由也不会实现刷新 , 所以要在 routes 路由配置对象中设置 data :{ reload : true } , 设置了这个属性,这个路由就不会被复用
  clickRightRefreshMe(evevt){
    //刷新选中的标签,进行路由跳转
    SwSimpleReuseStrategy.deleteRouteSnapshot(this.routerMenu.path) 
    this.menuList.forEach(item=>{
      if(item.path == this.routerMenu.path){
        item.isSelect = true
        //如果显示标签就是事件源标签,直接刷新没有作用,就统一先跳转到别的路由再跳转到事件源标签的路由
        this.router.navigateByUrl('').then(()=>{
          this.router.navigate([item.path],{
            queryParams:item.queryParams
          })
        })
      }else{
        item.isSelect = false
      }
    })
    this.el.nativeElement.style.display = 'none'
  }

  //5.点击关闭全部标签,跳转到工作台
  clickRightCloseAll(evevt){
    let index = 0  //工作台的索引是0,关闭除工作台之外的所有标签
    for(var i=this.menuList.length-1; i>0; i--){
      if(i > index){
        this.swTab.closeUrl(this.menuList[i].path,this.menuList[i].isSelect);
      }
    }
  }

  //触发滚轮事件,右键菜单消失
  @HostListener('document:mousewheel', ['$event']) onmousewheel(event) {
    this.el.nativeElement.style.display = 'none'
  } 
}

function clickBody(){
  $("body").click(function(e){
    if(e.which ==1) 
    {
      $("#rightClickMenu").hide();
      unbindclick()
    }
  })
}

function unbindclick(){
  $('body').unbind("click");
}
